import React from 'react';
import LayeringPills from '~/components/LayeringPills';

import './index.scss';

const classHeader = 'ndx-MobileBottomToolbar';

const MobileBottomToolbar = () => {
  return (
    <div className={`${classHeader} u-clickPassThrough`}>
      <LayeringPills />
    </div>
  );
};

MobileBottomToolbar.displayName = 'MobileBottomToolbar';

export default MobileBottomToolbar;
